import React from 'react';
import PropTypes from 'prop-types';
import {   withStyles,
  createMuiTheme,
  MuiThemeProvider } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import SideMenuList from "./SharedComponents/SideMenuList_try";
import ERMManagementDashboard from "./Dashboard/ERMManagementDashboard";
import {CapitalizeFirstLetter} from '../util/StringUtil';
import KRI from './Dashboard/ERMKRIDashboard'
import RiskRating from './Dashboard/ERMRiskRatingDashboard'
import ActionPlan from './Dashboard/ERMActionPlanDashboard'
import RiskAppetite from './Risks/RiskAppetite'
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import RiskInventory from './Risks/RiskInventory'
import RiskRegister from './Risks/RiskRegisterSummary'
import RiskParam from './Risks/RiskParam'
import KRIReporting from './KRI/KRIReportingSummary'
import KRIAlert from './KRI/KRIAlertSummary'
import logo from '../pic/KPMG_logo.svg.png'
import Tooltip from '@material-ui/core/Tooltip';
import config from '../config/config'
import axios from 'axios';
import setting from '../config/setting'
import {theme} from '../components/CSS/MenuStyles';

import {connect} from 'react-redux'
import {
  aDrawer
} from '../redux/actions'


const drawerWidth = 240

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 0,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 10,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 10,
    },
  },
  content: {
    overflow: 'auto',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    // padding: theme.spacing.unit * 3,
    marginTop: '58px',
    padding: '8px',
    // paddingTop: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  rootMenu: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested0: {
    paddingLeft: theme.spacing.unit * 4,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 2,
  },
  avatar: {
    width: 30,
    height: 30
  },
  thicc: {
    fontWeight: 600,
  },
  thiccer: {
    fontWeight: 600,
  }
});

class ClippedDrawer extends React.Component {
    state = {
        perspective: 'Dashboard',
        displayName: 'Dashboard',
        open: true,
        menuOpen: false,
        procurementOpen: false,
        ERMOpen: false,
        routinesOpen: false,
        transactionsOpen: false,
        riskRegisterState:[],
        alertDataState:[],
        EmployeeList:[]
    };
    handleDrawerOpen = () => {
      //console.log('open drawpaper')
        this.props.dDrawer(true)
    };

    handleDrawerClose = (event) => {
        if (this.props.open == true && event.pageX > 250) {
            console.log('close drawer')
            this.props.dDrawer(false)
        }
    };

    handleClick = () => {
        this.setState(state => ({ menuOpen: !state.menuOpen }))
    };
    handleRoute = (route, name) => {
        this.setState({ perspective: route, displayName: name ? name : route })
        this.props.history.push('/'+route.toLowerCase());
    }

    componentWillMount() {
        axios.defaults.headers.common["Authorization"] = 'token ' + this.props.token
        this.getRiskRegister()
        this.getKRIMonitoringDataUpdate()
        this.getKRIAlertDataUpdate()
        this.getEpmployeeList()
    }

    getEpmployeeList = () => {
        axios.get(config.employees).then((res)=>{
            // console.log('updated riskreg')
            // console.log(res)
            // fake key Tolerance data into alerts
            let data = res.data.results
            this.setState({EmployeeList: data })
        })
    }

    getRiskRegister = () => {
        axios.get(config.risks).then((res)=>{
            // console.log('updated riskreg')
            // console.log(res)
            // fake key Tolerance data into alerts
            let data = res.data.results
            //data[0].key_tolerance = 1
            //data[1].key_tolerance = 0
            //data[2].key_tolerance = 0
            //data[3].key_tolerance = 1

            this.setState({riskRegisterState: data })
        })
    };

    getKRIMonitoringDataUpdate = () => {
        //console.log('Update KRI Monitoring Data')
        axios.get(config.kri).then((res)=>{
            // console.log(res)
            this.setState({ krimonitoringState: res.data })
        })
    };

    getKRIAlertDataUpdate = () => {
        axios.get(config.allAlerts).then((res)=>{
            // console.log(res)
            this.setState({ alertDataState: res.data })
        })
    };

    render() {

        const threshold = {
            // R3K2  R5K1  R5K6
            lowkrithreshold: {R3KRI2: 10, R5KRI6: 280, R5KRI1: 180, R1K1: 5},
            highkrithreshold: {R3KRI2: 20, R5KRI6: 480, R5KRI1: 280, R1K1: 10}
        }


        const { classes } = this.props
        let toRender = null;
        const KRIDashboard = (<KRI threshold={threshold} alert={this.state.alertDataState} data={this.state.krimonitoringState}/>);
        const overview = (<ERMManagementDashboard alert={this.state.alertDataState} kridata={this.state.krimonitoringState} rrdata={this.state.riskRegisterState} handleRoute={this.handleRoute}/>);
        const RiskRatingDashboard = (<RiskRating />)
        const ActionPlanDashboard = (<ActionPlan data={this.state.riskRegisterState}/>)
        const riskInventory = (<RiskInventory fetchdata={()=>{this.getRiskRegister()}} data={this.state.riskRegisterState}/>)
        const riskRegister = this.state.riskRegisterState.length == 0 ? null : (<RiskRegister employee={this.state.EmployeeList} data={this.state.riskRegisterState} update={()=>{this.getRiskRegister()}}/>)
        const kRIReporting = (<KRIReporting threshold={threshold} data={this.state.krimonitoringState} update={this.getKRIMonitoringDataUpdate}/>)
        const kRIAlert = (<KRIAlert threshold={threshold} data={this.state.krimonitoringState} alert={this.state.alertDataState} update={this.getKRIAlertDataUpdate}/>)
        const RiskParameter = (<RiskParam/>)
        const riskappetite = (<RiskAppetite data={this.state.riskRegisterState}/>)
        let title = this.props.location.pathname.substr(1)

        let display = title
        switch (title) {
        case 'risk appetite':
            toRender = riskappetite
            break
        case 'risk parameters':
            toRender = RiskParameter
            break
        case 'alerts':
            toRender = kRIAlert
            display = 'KRI Alert'
            break
        case 'reporting':
            toRender = kRIReporting
            display = 'KRI Reporting'
            break
        case 'risk registers':
            toRender = riskRegister
            break
        case 'risk inventory':
            toRender = riskInventory
            break
        case 'key risk indicator':
            toRender = KRIDashboard
            break
        case 'risk rating':
            toRender = RiskRatingDashboard
            break
        case 'action plan':
            toRender = ActionPlanDashboard
            break
        case 'dashboard':
            // toRender = dashboard;
            toRender = overview
            break
        default:
            toRender = overview
            display = 'dashboard'
        }
    //console.log(this.props.open)
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root} onClick={this.handleDrawerClose}>
          <AppBar position="absolute" className={classNames(classes.appBar, this.props.open && classes.appBarShift)}>
            <Toolbar style={{ backgroundColor: "rgb(0,145,218)", minHeight: "58px" }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(classes.menuButton, this.props.open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" noWrap>
                {CapitalizeFirstLetter(display)}
              </Typography>
              <div style={{ flex: '1', textAlign: 'right' }}>
              {/* <img src={steve} style={{marginTop:"1%", width:"10%"}}/> */}
                <Tooltip title="Log Out" aria-label="Log Out">
                  <IconButton style={{ color: 'rgb(255,255,255)' }}
                    onClick={() => {
                      // console.log('log out'); 
                      this.handleLogOut();
                    }}>
                    <i class="fas fa-sign-out-alt fa-1x" ></i>
                  </IconButton>
                </Tooltip>
              </div>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(classes.drawerPaper, !this.props.open && classes.drawerPaperClose),
            }}
            open={this.props.open}
          >
            <div
              className={classes.toolbar}
            >
              <img src={logo} style={{ width: "100px", height: "auto", marginLeft: "auto", marginRight: "auto", marginTop: "10px" }} />
              {/*<IconButton onClick={this.handleDrawerClose}>
                          {!this.state.open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>*/}
            </div>
            <SideMenuList handleRoute={this.handleRoute} handleIconClick={this.handleDrawerOpen} shouldOpen={this.props.open}/>
          </Drawer>
          <main className={classes.content}>
            {toRender}
          </main>
        </div>
      </MuiThemeProvider>
    );
  }
}

ClippedDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
}

const mapStateToProps = (state, ownProps) => {
  // ... computed data from state and optionally ownProps
    return {
      open: state.open
    }
}

const mapDispatchToProps = dispatch => {
  // ... normally is an object full of action creators
    return {
      dDrawer: (open) => { dispatch(aDrawer(open)) }
    }
}

// `connect` returns a new function that accepts the component to wrap:
const connectToStore = connect(
  mapStateToProps,
  mapDispatchToProps
)

// and that function returns the connected, wrapper component:
const ConnectedComponent = connectToStore(withStyles(styles)(ClippedDrawer))
export default ConnectedComponent;



// WEBPACK FOOTER //
// ./src/components/ClippedDrawer.js